import { motion } from 'motion/react'

import { m } from '~/paraglide/messages.js'
import { useParagraphReveal } from '~/components/use-paragraph-reveal'

import { TickIcon } from './icons/tick'

const revealSteps = [
  { selector: '[data-a="1"]', at: 2 },
  { selector: '[data-a="2"]', at: 3 },
  { selector: '[data-a="3"]', at: 4 },
  { selector: '[data-a="4"]', at: 5 },
  { selector: '[data-a="5"]', at: 6 },
] as const

export function Page2Content({
  skipNonce,
  onRevealsComplete,
}: {
  skipNonce: number
  onRevealsComplete?: () => void
}) {
  const { scope } = useParagraphReveal({
    steps: revealSteps,
    skipNonce,
    onComplete: onRevealsComplete,
  })

  return (
    <motion.div
      ref={scope}
      className="flex w-full flex-col gap-6 pb-6 text-base text-white"
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    >
      <p data-a="1" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_commitment_body1()}
      </p>
      <p data-a="2" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_commitment_body2()}
      </p>
      <div className="flex flex-col gap-1">
        <div
          data-a="3"
          className="flex items-center gap-1"
          style={{ opacity: 0 }}
        >
          <TickIcon className="size-6 shrink-0" />
          <span>{m.pro_user_appreciation_letter_commitment_check1()}</span>
        </div>
        <div
          data-a="4"
          className="flex items-center gap-1"
          style={{ opacity: 0 }}
        >
          <TickIcon className="size-6 shrink-0" />
          <span>{m.pro_user_appreciation_letter_commitment_check2()}</span>
        </div>
      </div>
      <p data-a="5" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_commitment_body3()}
      </p>
    </motion.div>
  )
}
